<template>
  <div>
    <BreadCrumb :data="breadCrumb" />
    <Table
      :fields="fields" :items="warehouses" :filtered="filtered" type="List" :goDetail="goEdit" 
      :loading="isLoading" :limit="limit" :actions="actions" :actionEvent="actionEvent"
       addUrl="Warehouse/Add"
    />

    <Modals :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" 
      :form="currentForm" :modalName="modalName"
    />
  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import Table from "@/components/Table";
import Modals from "./modals/";
// import i18n from "@/plugins/i18n";

let breadCrumb = [{ label: "Depolar", url: "/Warehouse/List" }];

let fields = [
  { key: "name", label: "Adı", keys: ["name"] },
  { key: "string", label: "Adres", keys: ["address"] },
  { key: "type", type:'data', data:{true: {text: 'Takip Dışı', variant: 'dark'}, false: {text: 'Takip Edilecek', variant: 'success'}}, label: "Depo Tipi", keys: ["is_technical"] },
  { key: "total_product_count", label: "Toplam Ürün", keys: ["total_product_count"] },
  { key: "is_active", label: "Durum", keys: ["is_active"] },
  { key: "actions", label: "İşlemler" },
];

let actions = [
  { key: "products", text: "Depoya Ait Ürünler"},
  { key: "delete", text: "Sil" },
];
let filtered = [ "name", "string", "type", "is_active", "total_product_count","actions"];

export default {
  name: "WarehouseList",
 
  data: function () {
    return {
      breadCrumb, fields, filtered, actions,
      modalOpen: false, modalProps: {}, currentForm: "Warehouse", modalName: "",
    };
  },
  components: {
    BreadCrumb,
    Table,
    Modals
  },
  computed: {
    isLoading() {
      return this.$store.getters.getWarehouseLoading
    },
    warehouses() {
      return this.$store.getters.getWarehouses
    },
  },
  methods: {
    
    actionEvent: async function (key, data) {
      if (key == 'delete') {
        this.openModal(true, "delete", data);
      }else if(key == 'products'){
        this.$router.push({ path: `/Warehouse/${data.id}/Products` });
      }
    },

    goEdit(item) {
      this.$router.push({ path: `/Warehouse/${item.id}/Edit` });
    },

    openModal: function(state, modal, props){
      this.modalOpen = state
      if(state){
        this.modalProps = props
        this.modalName = modal
      }
    },
  },
  created() {
    this.$store.dispatch("warehouse_get");
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/ERP/Warehouse/List.vue